import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext, useAuthProvider } from './hooks/useAuth';
import AdminAuth from './components/AdminAuth';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import UploadMonitor from './pages/UploadMonitor';
import FailedUploads from './pages/FailedUploads';
import Users from './pages/Users';
import System from './pages/System';

function App() {
  const auth = useAuthProvider();

  return (
    <AuthContext.Provider value={auth}>
      <AdminAuth>
        <Routes>
          <Route path="/" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="uploads" element={<UploadMonitor />} />
            <Route path="uploads/failed" element={<FailedUploads />} />
            <Route path="users" element={<Users />} />
            <Route path="system" element={<System />} />
          </Route>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/auth/callback" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AdminAuth>
    </AuthContext.Provider>
  );
}

export default App;